export default "__VITE_ASSET__6423c66e__"